






































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DownloadPage extends Vue {
  downloads = [{
    text: 'Training Images and Annotations',
  }, {
    text: 'Validation Images and First Frame Annotations',
  }, {
    text: 'Test Images and First Frame Annotations'
  }]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/download.vue